import { Banner } from "interfaces";
import Link from "next/link";
import cls from "./bannerSingle.module.scss";
import Image from "next/image";
import { compactSlug, slugify } from "utils/slug";

type Props = {
  data: Banner;
  index?: number;
};

export default function BannerSingle({ data, index }: Props) {
  const isExternal = data?.action_type === "external";
  const isShop = data?.action_type === "shop";
  const isProduct = data?.action_type === "product";

  // ✅ Next/Image vuole sempre una stringa valida
  const imgSrc = (data?.img ?? "/placeholder.png") as string;

  // ✅ default (promotion)
  let href = `/promotion/${data?.id}`;

  // ✅ shop → /shop/{id}/{compactSlug(title)}
  if (isShop && data?.shops?.length) {
    const shop = data.shops[0];
    const title = shop?.translation?.title || "";
    const slug = compactSlug(title);

    if (shop?.id && slug) {
      href = `/shop/${shop.id}/${slug}`;
    }
  }

  // ✅ product → /product/{id}/{slugify(title)}
  if (isProduct && data?.product) {
    const product = data.product;
    const title = product?.translation?.title || product?.title || "";
    const slug = slugify(title);

    if (product?.id && slug) {
      href = `/product/${product.id}/${slug}`;
    }
  }

  const content = (
    <div className={cls.wrapper}>
      <Image
        fill
        priority={index === 0}
        loading={index !== 0 ? "lazy" : "eager"}
        src={imgSrc}
        alt={data?.translation?.title || "Banner Image"}
        quality={90}
        sizes="(max-width: 1140px) 1110px, 1500px"
        style={{
          objectFit: "cover",
          objectPosition: "center",
        }}
      />
    </div>
  );

  // ✅ external → link esterno
  if (isExternal) {
    return (
      <a
        href={data?.url || "#"}
        target="_blank"
        rel="noopener noreferrer"
        className={cls.banner}
      >
        {content}
      </a>
    );
  }

  // ✅ promotion + shop + product → Link interno
  return (
    <Link href={href} className={cls.banner}>
      {content}
    </Link>
  );
}

